import * as mutationTypes from './mutation-type.js'
export default {
    // 更新一级数据
    [mutationTypes.UP_SIMPLE_KEY](state, params) {
        Object.keys(params).forEach(key => {
            state[key] = params[key]
        })
    },
    [mutationTypes.UP_LIMIT_KEY](state, params) {
        let limitKeyValMap = {
            // 'home': 'home',
            // 'kol_mkt': 'kolMkt',
            // 'aggregator': 'aggregator',
            // 'local_media': 'localMedia',
            // 'authority':'authority'
            'home': 'home',
            'kol_mkt': 'kolMkt',
            'aggregator_mkt': 'aggregator',
            'local_mkt': 'localMedia',
            'authority':'authority',
            'adn_service':'adnService',
            'programmatic_mkt':'programmaticMkt',
            'programmatic_mkt_manage':'programmaticMktManage'
        }
        state.routerLimitMap = [];
        state.routerLimitObj = {};
        Object.keys(params).forEach(key => {
            let obj = {};

            if (params[key] && params[key].length > 0) {
                obj.name = limitKeyValMap[key];
                obj.limitFlag = true;
                state.routerLimitObj[limitKeyValMap[key]] = true;
            } else {
                obj.name = limitKeyValMap[key];
                obj.limitFlag = false;
                state.routerLimitObj[limitKeyValMap[key]] = false;
            }
            state.routerLimitMap.push(obj)
        })
    }
}


// WEBPACK FOOTER //
// ./src/stores/mutations.js